export default __webpack_public_path__ + "static/media/CurriculumActiveIcon.81b2fd34.svg";